export const constants = {
  VIEW_ENTRIES_PERPAGE_COUNT: [10, 25, 50, 100],
};
